module.exports = __webpack_public_path__ + "static/about.54f1bca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about.png
// module id = 1137
// module chunks = 263063586409284